<template>
  <div class="text-center">
    <v-dialog v-model="shower" width="560" scrollable persistent>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card class="rounded-lg">
          <v-card-title> {{ $t("Profile.pictext") }} </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-6">
            <v-layout row wrap justify-center align-center>
              <v-flex xs10 lg10 pt-6>
                <v-file-input
                  :rules="rules"
                  show-size
                  outlined
                  dense
                  v-model="FileUpload"
                  accept="image/png, image/jpeg"
                  prepend-icon="mdi-camera"
                  :label="$t('Profile.pictext2')"
                ></v-file-input>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn color="#077893" dark @click="Fn_Save()">
              {{ $t("policyForm.save") }}
            </v-btn>
            <v-btn color="#077893" outlined @click="close()">
              {{ $t("consentform.close") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  props: ["show", "_header", "_detail"],
  data: function () {
    return {
      valid: true,
      FileUpload: [],
      rules: [
        (value) => !value || value.size < 1000000 || this.$i18n.t("Profile.50"),
      ],
    };
  },
  computed: {
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogUpload");
        }
      },
    },
  },
  methods: {
    Fn_Save() {
      if (this.$refs.form.validate()) {
        const bodyFormData = new FormData();
        bodyFormData.append("BusinessId", this.$cookies.get("BusinessId"));
        bodyFormData.append("AccountId", this.$cookies.get("OneAccountId"));
        bodyFormData.append("FileLogo", this.FileUpload);

        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "business/UpdateLogoBusiness",
            bodyFormData
          )
          .then((response) => {
            this.loading = false;

            if (response.data.Status === "OK") {
              this.$emit("closeDialogUpload");
              this.$emit("reData");
              Toast.fire({
                icon: "success",
                title: this.$i18n.t("alert.imgupload"),
              });
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    close() {
      this.FileUpload = [];
      this.$refs.form.reset();
      this.$emit("closeDialogUpload");
    },
  },
};
</script>
